import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter, HostListener, Input,
  OnDestroy,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import {
  IFcDropdownSelectOption
} from "../../../../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import modesDropdownList from "./modes-dropdown-list.json";
import {BoosterMode, BoosterService} from "../../../services/booster.service";
import {first} from "rxjs/operators";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../../store';
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../../../../user/user-subscription";

@Component({
    selector: 'db-modes-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modes-list.component.html',
    styleUrls: ['./modes-list.component.scss'],
    standalone: false
})
export class ModesListComponent implements OnInit, OnDestroy {

  public toggled: boolean = false;
  public loading: boolean = false;
  public modeTitle: any;
  public modesList: Array<IFcDropdownSelectOption> = modesDropdownList;
  @Input() websiteId: number;
  @Input() index: number;
  @Input() userSubscription: UserSubscription;
  @Input() defaultModeLevel: string;
  @Input() pageId: number | 'front_page' | 'all';
  @Input() pageMode: string;
  @Input() paidClient: boolean;
  @Input() trialBoosterClient: boolean;
  @Input() showPercentOffer: boolean;
  @Output() modeChanged = new EventEmitter<any>();
  @ViewChild('selectDropdownToggle') selectDropdownToggle: ElementRef;
  @ViewChild('selectDropdown') selectDropdown: ElementRef;
  @ViewChild('dropDownTooltip') dropDownTooltip: ElementRef;


  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _cdRef: ChangeDetectorRef,
    private $element: ElementRef,
    private _boosterService: BoosterService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.modeTitle = this.modesList.find(mode => mode.value === this.pageMode) && this.modesList.find(mode => mode.value === this.pageMode).label;
  }

  public selectMode(mode): void {
    this.toggled = false;
    this.validatePageUrl(mode, this.index);
  }

  public validatePageUrl(mode: BoosterMode, index: number): void {
    if ( TypeUtils.isUndefined(this.pageId)) return;
    this.modeChanged.emit({loading: true, index: index, mode: mode});
    this.loading = true;
    this.pageMode = mode;
    this.modeTitle = this.modesList.find(mode => mode.value === this.pageMode).label;
    this._applyBoosterMode(mode, index);
  }

  public toggle(): void {
    this.toggled = !this.toggled;
  }

  private _applyBoosterMode(mode: BoosterMode, index: number): void {
    this._boosterService.applyBoosterMode(this.websiteId, this.pageId, mode, 1)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.loading = false;
        this.toggled = false;
        this.modeChanged.emit({loading: false, index: index, mode: mode});
      });
  }

  ngOnDestroy() {
  }


  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
    if ($event.target && this.$element.nativeElement.contains($event.target)
      && !$event.target.parentElement.parentElement.classList.contains('db-modes-list__mode-item') && !this.loading) {
      this.toggle()
    } else { this.toggled = false; }
  }

  public sendEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Upgrade button click',
      eventLabel: 'Speed Booster: Change level page management',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

}
